import {lazy, Suspense} from "react"

const RiveView = lazy(() =>
  import('./RiveView').then(module => ({default: module.RiveView}))
)

export function RiveLoad({toLoad = true, width, height, image, style: st, ...props}) {
  const style = {aspectRatio: width / height, ...st}

  if (toLoad && image)
    style.backgroundImage = `url(${image})`

  // return <div className={'rive' + (toLoad ? ` load${image ? '-image' : ''}` : '')} style={style}/>

  // <Spinner style={style}/>
  return (
    <Suspense fallback={
      <div className={'rive' + (toLoad ? ` load${image ? '-image' : ''}` : '')} style={style}/>
    }>
      <RiveView toLoad={toLoad} width={width} height={height} image={image} style={st} {...props}/>
    </Suspense>
  )
}